// src/components/Header.jsx
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useStickyNavbar } from "../hooks/useStickyNavbar";
import darkLogo from "../assets/images/logo/logo_png_dark.png";
import lightLogo from "../assets/images/logo/logo_png_light.png";
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isServicesOpen, setIsServicesOpen] = useState(false); // NEW
  const isSticky = useStickyNavbar(150);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close services dropdown when mobile menu closes
  const handleToggleMenu = () => {
    setIsMenuOpen((prev) => {
      if (prev) setIsServicesOpen(false); // reset when closing menu
      return !prev;
    });
  };

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const apiUrl = localStorage.getItem("api_url");
      const companyId = "1";
      const employeeId = "1";

      const formData = new FormData();
      formData.append("company_id", companyId);
      formData.append("employee_id", employeeId);
      formData.append("type", "1");

      const response = await fetch(`${apiUrl}service.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "1") {
        setServices(data.result);
      } else {
        setServices([]);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      setServices([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <header className={`header header-transparent header-layout3`}>
      <div className="header-topbar d-none d-sm-block">
        <div
          className="container-fluid h-100"
          style={{ backgroundColor: "#000" }}
        >
          <div className="row align-items-center h-100">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <ul className="contact-list d-flex flex-wrap align-items-center list-unstyled mb-0">
                <li>
                  <i className="icon-email" />
                  <Link
                    href={`mailto:${localStorage.getItem("company_email") || "sales@sunshineinfotech.in"}`}
                  >
                    <span>
                      {localStorage.getItem("company_email") ||
                        "sales@sunshineinfotech.in"}
                    </span>
                  </Link>
                </li>
                <li>
                  <FaPhone />
                  <Link
                    href={`tel:${localStorage.getItem("company_mobile_1") || "+919316392980"}`}
                  >
                    <span>
                      {localStorage.getItem("company_mobile_1") ||
                        "+91 93163 92980"}
                    </span>
                  </Link>
                </li>
              </ul>
              <div className="d-flex align-items-center">
                <ul className="social-icons list-unstyled mb-0">
                  <li>
                    <Link
                      target="_blank"
                      to={localStorage.getItem("company_fb_link") || "#"}
                    >
                      <FaFacebookF size={16} />
                    </Link>
                  </li>
                  <li>
                    <Link
                      target="_blank"
                      to={localStorage.getItem("company_linkedIn_link") || "#"}
                    >
                      <FaLinkedinIn size={16} />
                    </Link>
                  </li>
                  <li>
                    <Link
                      target="_blank"
                      to={localStorage.getItem("company_insta_link") || "#"}
                    >
                      <FaInstagram size={16} />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav
        className={`navbar navbar-expand-lg sticky-navbar ${isSticky ? "is-sticky" : ""}`}
      >
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img
              src={localStorage.getItem("company_footer_logo_url") || lightLogo}
              className="logo-light"
              alt="logo"
            />
            <img
              src={localStorage.getItem("company_footer_logo_url") || darkLogo}
              className="logo-dark"
              alt="logo"
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            onClick={handleToggleMenu}
          >
            <span className="menu-lines">
              <span></span>
            </span>
          </button>

          <div
            className={`collapse navbar-collapse ${isMenuOpen ? "menu-opened" : ""}`}
            id="mainNavigation"
          >
            <ul className="navbar-nav ms-auto">
              <li className="nav-item has-dropdown">
                <Link
                  onClick={() => setIsMenuOpen(false)}
                  to="/"
                  className={`nav-item-link ${isActive("/") ? "active" : ""}`}
                >
                  Home
                </Link>
              </li>

              <li className="nav-item has-dropdown">
                <Link
                  onClick={() => setIsMenuOpen(false)}
                  to="/about-us"
                  className={`nav-item-link ${isActive("/about-us") ? "active" : ""}`}
                >
                  Who We Are
                </Link>
              </li>

              {/* ── Services with mobile expand/collapse ── */}
              <li
                className={`nav-item has-dropdown ${isServicesOpen ? "mobile-services-open" : ""}`}
              >
                <div className="services-nav-row">
                  <Link
                    to="/services"
                    className={`nav-item-link ${location.pathname.includes("/services") ? "active" : ""} ${isSticky ? "is-sticky" : ""}`}
                    style={{
                      color:
                        typeof window !== "undefined" && window.innerWidth < 992
                          ? "#4C4C4C"
                          : "#fff",
                    }}
                  >
                    Services
                  </Link>

                  {/* Chevron toggle — visible only on mobile via CSS */}
                  <button
                    className="services-toggle-btn d-lg-none"
                    onClick={() => setIsServicesOpen((prev) => !prev)}
                    aria-label="Toggle services menu"
                    aria-expanded={isServicesOpen}
                  >
                    <FaChevronDown
                      size={12}
                      style={{
                        transition: "transform 0.3s ease",
                        transform: isServicesOpen
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      }}
                    />
                  </button>
                </div>

                {/* Dropdown — always visible on desktop (CSS hover), toggled on mobile */}
                <ul
                  className="dropdown-menu"
                  style={
                    // Only apply inline style on mobile; desktop relies on CSS hover
                    typeof window !== "undefined" && window.innerWidth < 992
                      ? {
                          display: isServicesOpen ? "block" : "none",
                          position: "static",
                          boxShadow: "none",
                          padding: "0 0 0 1rem",
                        }
                      : {}
                  }
                >
                  {loading ? (
                    <li className="nav-item">
                      <span className="nav-item-link">Loading services...</span>
                    </li>
                  ) : services.length > 0 ? (
                    services.map((service) => (
                      <li className="nav-item" key={service.service_id}>
                        <Link
                          to={`/serviceDetails/${service.service_id}`}
                          className="nav-item-link"
                          onClick={() => {
                            setIsServicesOpen(false);
                            setIsMenuOpen(false);
                          }}
                        >
                          {service.service_title}
                        </Link>
                      </li>
                    ))
                  ) : (
                    <li className="nav-item">
                      <span className="nav-item-link">
                        No services available
                      </span>
                    </li>
                  )}
                </ul>
              </li>
              {/* ── end Services ── */}

              <li className="nav-item has-dropdown">
                <Link
                  onClick={() => setIsMenuOpen(false)}
                  to="/pricing"
                  className={`nav-item-link ${isActive("/pricing") ? "active" : ""}`}
                >
                  Pricing
                </Link>
              </li>

              <li className="nav-item has-dropdown">
                <Link
                  onClick={() => setIsMenuOpen(false)}
                  to="/careers"
                  className={`nav-item-link ${isActive("/careers") ? "active" : ""}`}
                >
                  Careers
                </Link>
              </li>

              <li className="nav-item has-dropdown">
                <Link
                  onClick={() => setIsMenuOpen(false)}
                  to="/blogs"
                  className={`nav-item-link ${isActive("/blogs") ? "active" : ""}`}
                >
                  Blog
                </Link>
              </li>

              <li className="nav-item has-dropdown">
                <Link
                  onClick={() => setIsMenuOpen(false)}
                  to="/faq"
                  className={`nav-item-link ${isActive("/faq") ? "active" : ""}`}
                >
                  FAQ
                </Link>
              </li>

              <li className="nav-item has-dropdown">
                <Link
                  onClick={() => setIsMenuOpen(false)}
                  to="/contact-us"
                  className={`nav-item-link ${isActive("/contact-us") ? "active" : ""}`}
                >
                  Contact Us
                </Link>
              </li>
            </ul>

            <button
              className="close-mobile-menu d-flex justify-content-center align-items-center d-lg-none"
              onClick={handleToggleMenu}
            >
              <i className="icon-close"></i>
            </button>
          </div>

          <ul className="navbar-actions d-flex flex-row-reverse flex-lg-row align-items-center list-unstyled mb-0">
            <li>
              <Link
                to="/bookMeeting"
                className="btn btn-white btn-white-style2 action-btn action-btn-contact arrow-hover-flip-up"
              >
                <span>Talk to Our Team</span>
                <svg
                  className="arrow-flip"
                  viewBox="0 0 64 64"
                  width="10"
                  height="10"
                >
                  <g className="arrow-flip-path-1">
                    <path
                      d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                      fill="currentColor"
                    ></path>
                  </g>
                  <g className="arrow-flip-path-2">
                    <path
                      d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                      fill="currentColor"
                    ></path>
                  </g>
                </svg>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
